import React from 'react';
import { observer } from 'mobx-react';

import { FormattedTimeWindow } from './formatted-time-window';
import { useStores } from '../../../recipes';

interface Props {
	alertId: string;
}

const TimeWindowCell = ({ alertId }: Props) => {
	const {
		alertsStore: { getTaskAlert },
		merchantConfigurationsStore: { hourStringFormat }
	} = useStores();
	const alert = getTaskAlert(alertId);

	if (!alert) {
		return null;
	}

	const { actionableWayPoint: wp, timezone } = getTaskAlert(alertId);

	if (!wp || !wp.no_earlier_than || !wp.no_later_than) {
		return <>-- : --</>;
	}
	return (
		<>
			<FormattedTimeWindow
				firstDate={wp.no_earlier_than}
				secondDate={wp.no_later_than}
				timezone={timezone}
				hoursFormat={hourStringFormat}
			/>
		</>
	);
};

export default observer(TimeWindowCell);
